import { useSelector } from "react-redux";
import { injectIntl } from "react-intl";
import { Badge, Box, Stack, Tooltip, Typography } from "@mui/material";
import { UPDATE_PRESTAZIONE } from "../../../modules/language";
import {
  PREFIX_LABEL_PRESTAZIONE,
  PREFIX_STATO_PRESTAZIONE,
  ID_PRESTAZIONE,
  TIPOLOGIA_PRESTAZIONE,
  STATO_PRESTAZIONE,
  ORDINE_PRESTAZIONE,
  ottieniIconaPrestazione,
  getOpenedNotification,
  PRESTAZIONI_CHANGED,
} from "../../../modules/tracking";
import { getMessageString } from "../../../utility";
import { Empty, Icona } from "../../shared";

export const Tridimensional = injectIntl(({ intl, timeline }) => {
  const openedNotification = useSelector(getOpenedNotification);
  var prestazioniChanged = [];
  for (const [, value] of Object.entries(openedNotification[PRESTAZIONI_CHANGED])) {
    prestazioniChanged = prestazioniChanged.concat(value);
  }

  return (
    <Stack sx={{ p: "12px 0", width: "100%", position: "relative", display: "grid" }}>
      {timeline.length > 0 ? (
        <>
          {timeline.map((stato, index) => (
            <Stack {...(prestazioniChanged.includes(stato[ID_PRESTAZIONE]) && { className: "prestazioneAggiornata" })} key={index}>
              <Badge
                badgeContent={
                  <Tooltip title={getMessageString(intl, UPDATE_PRESTAZIONE)} placement="top" arrow>
                    <Stack>
                      <Icona tipologia="cambio_cura" />
                    </Stack>
                  </Tooltip>
                }
              >
                <Box className="tridimensional">
                  <Box className="top" />
                  <Box className="info">
                    <Icona tipologia={ottieniIconaPrestazione(stato[TIPOLOGIA_PRESTAZIONE])} />
                    <Typography className="descrizione">
                      {getMessageString(intl, PREFIX_LABEL_PRESTAZIONE + stato[TIPOLOGIA_PRESTAZIONE], { order: stato[ORDINE_PRESTAZIONE] })}
                    </Typography>
                    <Typography className="esito">{getMessageString(intl, PREFIX_STATO_PRESTAZIONE + stato[STATO_PRESTAZIONE])}</Typography>
                  </Box>
                  <Box className="bottom" />
                </Box>
              </Badge>
            </Stack>
          ))}
          <Box className="tridimensionalTimeline">
            <Stack className="timelineEnd" />
          </Box>
        </>
      ) : (
        <Empty />
      )}
    </Stack>
  );
});
